import { cn } from "@/lib/utils";
import { useEffect, useRef, useState } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

type TruncationWithTooltipProps = React.PropsWithChildren<{
  className?: string;
}>;

export const TruncationWithTooltip = ({
  children,
  className,
}: TruncationWithTooltipProps) => {
  const textElementRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!textElementRef.current) {
      return;
    }

    const handleResize = () => {
      const textElement = textElementRef.current;
      if (textElement) {
        setIsOverflowing(
          textElement.scrollWidth > textElement.clientWidth ||
            textElement.scrollHeight > textElement.clientHeight,
        );
      }
    };

    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(textElementRef.current);
  }, []);

  const handleOnOpenChange = (isOpen: boolean) => {
    if (isOverflowing) {
      setOpen(isOpen);
    }
  };

  return (
    <Tooltip open={open} onOpenChange={handleOnOpenChange}>
      <TooltipContent className="max-w-100">{children}</TooltipContent>
      <TooltipTrigger asChild>
        <div
          ref={textElementRef}
          className={cn(
            { truncate: !className?.includes("line-clamp") },
            className,
          )}
        >
          {children}
        </div>
      </TooltipTrigger>
    </Tooltip>
  );
};
